import React from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

const ProgressSteps = ({ currentStep, isMerchant = false }) => {
  // Define steps based on user type
  // For the new flow: Phone -> OTP -> Profile (with agreement upload)
  const steps = isMerchant 
    ? [
        { id: 1, label: 'Phone', key: 'phone' },
        { id: 2, label: 'OTP', key: 'otp' },
        { id: 3, label: 'Details', key: 'register' },
      ]
    : [
        { id: 1, label: 'Phone', key: 'phone' },
        { id: 2, label: 'OTP', key: 'otp' },
        { id: 3, label: 'Profile', key: 'profile' },
      ];

  const getStepStatus = (stepKey) => {
    const stepOrder = ['phone', 'otp', 'register', 'profile', 'agreement'];
    const currentIndex = stepOrder.indexOf(currentStep);
    const stepIndex = stepOrder.indexOf(stepKey);
    
    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) return 'current';
    return 'upcoming';
  };

  return (
    <div className="w-full max-w-md mx-auto mb-10 px-4">
      <nav aria-label="Progress">
        <ol className="flex items-center">
          {steps.map((step, stepIdx) => {
            const status = getStepStatus(step.key);
            const isLast = stepIdx === steps.length - 1;
            
            return (
              <li key={step.id} className={`relative ${isLast ? '' : 'flex-1'}`}>
                <div className="flex items-center">
                  {/* Circle */}
                  <div className="relative flex flex-col items-center">
                    {status === 'completed' ? (
                      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-600 shadow-md">
                        <CheckIcon className="h-5 w-5 text-white" />
                      </div>
                    ) : status === 'current' ? (
                      <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-primary-600 bg-white shadow-md">
                        <span className="h-3 w-3 rounded-full bg-primary-600" />
                      </div>
                    ) : (
                      <div className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-gray-300 bg-white">
                        <span className="h-2.5 w-2.5 rounded-full bg-gray-300" />
                      </div>
                    )}
                    
                    {/* Label */}
                    <span
                      className={`absolute top-12 whitespace-nowrap text-xs font-medium ${
                        status === 'completed' || status === 'current'
                          ? 'text-primary-600'
                          : 'text-gray-400'
                      }`}
                    >
                      {step.label}
                    </span>
                  </div>
                  
                  {/* Connector Line */}
                  {!isLast && (
                    <div
                      className={`flex-1 h-0.5 mx-2 ${
                        status === 'completed' ? 'bg-primary-600' : 'bg-gray-200'
                      }`}
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default ProgressSteps;
